var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Client(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-_client",
    "data-name": "icon-24- client",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7074",
    "data-name": "Rectangle 7074",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-svgrepo-com",
    transform: "translate(-0.25 -0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M12,13.75a5.76,5.76,0,1,1,4.063-1.687A5.75,5.75,0,0,1,12,13.75Zm0-10A4.26,4.26,0,1,0,15,5,4.25,4.25,0,0,0,12,3.75Z",
    fill: "#02466a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M21,21.75a.76.76,0,0,1-.75-.75A7.26,7.26,0,0,0,13,13.75H11A7.26,7.26,0,0,0,3.75,21a.75.75,0,0,1-1.5,0A8.76,8.76,0,0,1,11,12.25h2A8.76,8.76,0,0,1,21.75,21a.76.76,0,0,1-.75.75Z",
    fill: "#02466a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Client);
export default __webpack_public_path__ + "static/media/icon-24-client.ef49de17fc9018256ffb1f4a0c19b2a8.svg";
export { ForwardRef as ReactComponent };